var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5303 3.54975C15.8232 3.84264 15.8232 4.31752 15.5303 4.61041L9.01033 11.1304C8.53322 11.6075 8.53322 12.3926 9.01033 12.8697L15.5303 19.3897C15.8232 19.6826 15.8232 20.1575 15.5303 20.4504C15.2374 20.7433 14.7626 20.7433 14.4697 20.4504L7.94967 13.9304C6.88677 12.8675 6.88677 11.1326 7.94967 10.0697L14.4697 3.54975C14.7626 3.25685 15.2374 3.25685 15.5303 3.54975Z",
    fill: "#16151C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c95140fb1eac6c9f51561503f04b848b.svg";
export { ForwardRef as ReactComponent };